const carPassCard = () => import('@/pages/carPassCard/index')
const carPassCardDetail = () => import('@/pages/carPassCard/detail/index')
const yearCheckPage = () => import('@/pages/carPassCard/pending/yearCheckPage')
const recordDetail = () => import('@/pages/carPassCard/detail/recordDetail')
const recordDetailList = () => import('@/pages/carPassCard/detail/recordDetailList')
const moreHandle = () => import('@/pages/carPassCard/moreHandle')

export default [
  {
    path: '/carPassCard',
    name: 'carPassCard',
    component: carPassCard,
    meta: {
      storeKey: 'mtc.renewal.permit'
    }
  },
  {
    path: '/carPassCardDetail',
    name: 'carPassCardDetail',
    component: carPassCardDetail,
    meta: {
    }
  },
  {
    path: '/carPassCheckPage',
    name: 'carPassCheckPage',
    component: yearCheckPage,
    meta: {
    }
  },
  {
    path: '/carPassRecordDetail',
    name: 'carPassRecordDetail',
    component: recordDetail,
    meta: {
    }
  },
  {
    path: '/carPassRecordDetailList',
    name: 'carPassRecordDetailList',
    component: recordDetailList,
    meta: {
    }
  },
  {
    path: '/carPassMoreHandle',
    name: 'carPassMoreHandle',
    component: moreHandle,
    meta: {
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/carPassCard/index.js